import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-payment-response-error-success',
  template: `
    <div class="response-container">
      <div class="icon">
        <ng-container [ngSwitch]="resultStatus">
          <ng-container *ngSwitchCase="'success'">
            <image-loader-utils url="success" extraClasses="success"></image-loader-utils>
          </ng-container>
          <ng-container *ngSwitchCase="'error'">
            <image-loader-utils extraClasses="error-icon" url="close"></image-loader-utils>
          </ng-container>
          <ng-container *ngSwitchCase="'pending'">
            <image-loader-utils url="info-circle" extraClasses="info-circle"></image-loader-utils>
          </ng-container>
        </ng-container>
        <div class="response-message">
          <h3>{{ message }}</h3>
          <p *ngIf="subMessage">{{ subMessage }}</p>
        </div>
        <div>
          <div [ngClass]="resultStatus" class="response-action-button" *ngIf="actionText" (click)="onAction()">{{ actionText }}</div>
        </div>
      </div>
    </div>
  `,
})
export class PaymentResponseErrorSuccessComponent {
  @Input() isSuccess: boolean;
  @Input() message: string;
  @Input() subMessage?: string;
  @Input() actionText?: string;
  @Input() isPending?: boolean;
  @Output() action = new EventEmitter<void>();

  @Input() resultStatus: 'success' | 'error' | 'pending';
  //ngOnInit() {
  //  // Initialization logic if needed
  //}

  //ngOnChanges() {
  //
  //  // Change detection logic if needed
  //}

  onAction() {
    this.action.emit();
  }
}
